"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ComponentLoader", {
  enumerable: true,
  get: function get() {
    return _loader["default"];
  }
});
exports["default"] = void 0;

var _loader = _interopRequireDefault(require("./loader"));

var _indexService = _interopRequireDefault(require("./indexService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classPrivateFieldLooseBase(receiver, privateKey) { if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) { throw new TypeError("attempted to use private field on non-instance"); } return receiver; }

var id = 0;

function _classPrivateFieldLooseKey(name) { return "__private_" + id++ + "_" + name; }

var _loaderInstance = _classPrivateFieldLooseKey("loaderInstance");

var Component = /*#__PURE__*/function () {
  function Component(element) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var loaderInstance = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Component);

    Object.defineProperty(this, _loaderInstance, {
      writable: true,
      value: void 0
    });
    this.$id = "$id_".concat((0, _indexService["default"])());
    this.$container = element;
    this.$options = _objectSpread({}, options);
    _classPrivateFieldLooseBase(this, _loaderInstance)[_loaderInstance] = loaderInstance;
  }

  _createClass(Component, [{
    key: "$setOptions",
    value: function $setOptions(options) {
      var DEFAULTS = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      Object.assign(this.$options, DEFAULTS, options);
    }
  }, {
    key: "$debug",
    value: function $debug() {
      var _console;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_console = console).debug.apply(_console, [this.$id].concat(args));
    }
  }, {
    key: "$publish",
    value: function $publish(subscription) {
      var _classPrivateFieldLoo;

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (_classPrivateFieldLoo = _classPrivateFieldLooseBase(this, _loaderInstance)[_loaderInstance]).publish.apply(_classPrivateFieldLoo, [subscription, this.$id].concat(args));
    }
  }, {
    key: "$subscribe",
    value: function $subscribe(subscription, callback) {
      _classPrivateFieldLooseBase(this, _loaderInstance)[_loaderInstance].subscribe(subscription, callback, this);
    }
  }, {
    key: "$unsubscribe",
    value: function $unsubscribe(subscription, callback) {
      _classPrivateFieldLooseBase(this, _loaderInstance)[_loaderInstance].unsubscribe(subscription, callback, this);
    }
  }]);

  return Component;
}();

exports["default"] = Component;
Component.loaderPriority = 'idle';
Component.loaderPriorityDelay = 0;
//# sourceMappingURL=index.js.map